import React from 'react'

const SuccessTick = () => {
    return (
        <svg
            width="62"
            height="62"
            viewBox="0 0 86 86"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M43 11.125C60.6041 11.125 74.875 25.3959 74.875 43C74.875 60.6041 60.6041 74.875 43 74.875C25.3959 74.875 11.125 60.6041 11.125 43C11.125 25.3959 25.3959 11.125 43 11.125ZM39.2207 48.3779L31.3379 40.4961L28.834 43L26.3291 45.5039L36.9541 56.1289L39.6963 58.8721L42.1797 55.8926L59.8877 34.6426L54.4463 30.1074L39.2207 48.3779Z"
                fill="#F287B7"
            />
        </svg>
    )
}

export default SuccessTick